const Clipboard = require('clipboard')
const Hammer = require('hammerjs')
const Fullscreen = require('./fullscreen')
const {bind} = require('../lib/bind')
const cancelEvent = require('../lib/cancel-event')

require('../lib/array-from')
require('../lib/closest')

class Player {
  constructor(element) {
    this.element = element
    new Fullscreen(element)

    this.scrubberElement = element.querySelector('.js-sd-player-scrubber')
    this.progressElement = element.querySelector('.js-sd-player-scrubber-progress')
    this.previewElement = element.querySelector('.js-sd-player-preview')
    this.currentSlideElement = element.querySelector('.js-sd-player-current-slide')
    this.currentSlideNote = element.querySelector('.current-slide-note')
    this.showSlideNotes = false
    this.nextSlideElement = element.querySelector('.js-sd-player-next-slide')
    this.previousSlideElement = element.querySelector('.js-sd-player-previous-slide')
    this.slidePresenterElement = element.querySelector('.js-sd-player-presenter')
    this.ratio = parseFloat(element.dataset.ratio)
    this.draggingScrubber = false
    this.slideCount = this.slideElements().length
    this.embed_width = 560
    this.embed_height = Math.floor(this.embed_width / this.ratio)
    this.preloadSlides()
    this.setupListeners()
    this.sizePreview()
    this.setupClipboards()
    this.showSlide(element.dataset.startSlide)
  }

  preloadSlides(from = 0, count = 3) {
    this.slideElements().slice(Math.max(from, 0), count).forEach(function(element) {
      element.style.backgroundImage = `url('${element.dataset.url}')`
    })
  }

  slideElements() {
    return Array.from(this.element.querySelectorAll('.js-sd-slide'))
  }

  showSlide(index) {

    if (this.isPanning()) {
      return false
    }

    index = parseInt(index)
    this.preloadSlides(index - 3, index + 5);
    const backgroundImage = this.slideElements()[index].style.backgroundImage
    const img = backgroundImage.match(/url\((.*?)\)/)[1].replace(/"/g, '')

    // Slide Notes
    const slideNote = this.slideElements()[index].dataset.slideNote
    if(slideNote.length){
      this.currentSlideNote.innerHTML = slideNote
      if(this.showSlideNotes == true) this.currentSlideNote.removeAttribute('hidden')
    } else {
      this.currentSlideNote.innerHTML = ''
      this.currentSlideNote.setAttribute('hidden', true)
    }

    this.currentSlideElement.style.backgroundImage = backgroundImage

    if (this.slideElements()[index + 1]) {
      this.nextSlideElement.style.backgroundImage = this.slideElements()[index + 1].style.backgroundImage
    } else {
      this.nextSlideElement.style.backgroundImage = null
    }

    if (this.slideElements()[index - 1]) {
      this.previousSlideElement.style.backgroundImage = this.slideElements()[index - 1].style.backgroundImage
    } else {
      this.previousSlideElement.style.backgroundImage = null
    }

    this.currentSlide = index;
    this.disablePreviousNext()
    this.updateScrubberProgress()

    var event = new CustomEvent('sd:embed:image', {
      detail: {
        index: index,
        cssUrl: backgroundImage,
        imgUrl: img
      }
    })
    try { window.parent.document.dispatchEvent(event) }
    catch(e){
      console.log(e)
    }
  }

  disablePreviousNext() {
    const previousButtons = Array.from(this.element.querySelectorAll('.js-sd-player-previous'))
    const nextButtons = Array.from(this.element.querySelectorAll('.js-sd-player-next'))

    if (this.isFirstSlide()) {
      previousButtons.forEach((element) => {
        element.classList.remove('active')
      })
    } else {
      previousButtons.forEach((element) => {
        element.classList.add('active')
      })
    }

    if (this.isLastSlide()) {
      nextButtons.forEach((element) => {
        element.classList.remove('active')
      })
    } else {
      nextButtons.forEach((element) => {
        element.classList.add('active')
      })
    }
  }

  setupClipboards() {
    Array.from(this.element.querySelectorAll('[data-clipboard-text]')).forEach((element) => {
      const clipboard = new Clipboard(element)
      clipboard.on('success', (e) => {
        const text = element.innerText
        element.innerText = 'Copied!'
        setTimeout(() => {
          element.innerText = text
        }, 2000)
      })
    })
  }

  updateShareSlideLinks() {
    const slide = this.currentSlide + 1
    const linkStart = document.querySelector('.js-sd-player-link-start')
    const linkSlide = document.querySelector('.js-sd-player-link-slide')
    const embedStart = document.querySelector('.js-sd-player-embed-start')
    const embedSlide = document.querySelector('.js-sd-player-embed-slide')
    linkSlide.dataset.clipboardText = linkStart.dataset.clipboardText + `?slide=${slide}`.replace(/\?slide=1$/, '')
    embedSlide.dataset.clipboardText = embedStart.dataset.clipboardText.replace('class="speakerdeck-embed"', `class="speakerdeck-embed" data-slide="${slide}"`)

    // iframe embeds
    const iframeEmbedStart = document.querySelector('.iframe-sd-player-embed-start')
    const iframeEmbedSlide = document.querySelector('.iframe-sd-player-embed-slide')

    const doc = new DOMParser().parseFromString(window.frameElement.outerHTML, 'text/html')
    let iframe = doc.querySelector('iframe')
    iframe.src = iframe.src.split('?')[0]; // Remove query params
    iframe.style.width = '100%'
    iframe.style.height = 'auto'
    iframe.style.aspectRatio = `${this.embed_width}/${this.embed_height}`
    iframe.setAttribute('data-ratio', this.embed_width/this.embed_height)
    iframeEmbedStart.dataset.clipboardText = iframe.outerHTML

    // From Slide
    iframe.src = iframe.src + `?slide=${slide}`
    iframeEmbedSlide.dataset.clipboardText = iframe.outerHTML

    this.updateFacebookButton(slide)
    this.updateTwitterButton(slide)
  }

  updateFacebookButton(slide) {
    const button = document.querySelector('.js-facebook-button-slide')
    const url = encodeURIComponent(`${document.querySelector('.js-facebook-button-start').dataset.url}?slide=${slide}`.replace(/\?slide=1$/, ''))
    button.setAttribute('data-url', url)
  }

  updateTwitterButton(slide) {
    const link = document.querySelector('.js-twitter-button-slide')
    const url = link.href.replace(/\?slide=.+$/, `?slide=${slide}`)
    link.setAttribute('href', url)
  }

  updateScrubberProgress() {
    this.progressElement.style.width = `${100 * this.currentSlide / (this.slideCount - 1)}%`
  }

  isFirstSlide() {
    return this.currentSlide == 0
  }

  isLastSlide() {
    return this.currentSlide == this.slideCount - 1
  }

  showControls() {
    this.element.classList.add('show-controls')
  }

  hideControls() {
    this.removeInitialState()
    this.element.classList.remove('show-controls')
  }

  setupListeners() {
    bind('.js-sd-player-next', 'click', this.clickNext.bind(this))
    bind('.js-sd-player-previous', 'click', this.clickPrevious.bind(this))
    bind(this.scrubberElement, 'mousemove', this.showPreview.bind(this))
    bind(this.scrubberElement, 'mouseout', this.hidePreview.bind(this))
    bind(this.scrubberElement, 'mousedown', this.startScrubberDrag.bind(this))
    bind(this.scrubberElement, 'mouseup', this.endScrubberDrag.bind(this))
    bind('.js-sd-player-share', 'click', this.toggleShare.bind(this))

    bind('.js-sd-player-notes', 'click', this.toggleNotes.bind(this))

    bind('.js-sd-player-share-close', 'click', this.hideShare.bind(this))
    bind('.js-sd-player-share-selector', 'click', this.selectShareAction.bind(this))
    bind(this.element, 'mouseout', this.removeInitialState.bind(this))
    bind(this.element, 'mouseenter', this.showControls.bind(this))
    bind(this.element, 'mouseleave', this.hideControls.bind(this))

    bind(document, 'keydown', (e) => {
      this.handleKeyDown(e.keyCode);
    })

    bind(window, "message", this.receiveMessage.bind(this), false);

    Array.from(document.querySelectorAll('.fb-share-button')).forEach((element) => {
      element.addEventListener('click', function(e){
        e.preventDefault()
        let title = encodeURIComponent(document.title)
        let url = e.target.getAttribute('data-url')
        let app_id = e.target.getAttribute('data-app_id')
        window.open('https://www.facebook.com/dialog/share?app_id='+ app_id +'&display=popup&href=' + url + '&title=' + title, "_blank", "toolbar=no,menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes,width=600,height=400,modal=yes,alwaysRaised=yes");
      }, false)
    })

    Array.from(document.querySelectorAll('.twitter-share-button')).forEach((element) => {
      element.addEventListener('click', function(e){
        e.preventDefault()
        if (e.target.tagName.toLowerCase() !== 'a') return
        window.open(e.target.href, "_blank", "toolbar=no,menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes,width=600,height=400,modal=yes,alwaysRaised=yes");
      }, false)
    })

    const hammer = new Hammer(this.element, {})
    hammer.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    hammer.on('pan', this.handlePan.bind(this));
  }

  clickNext() {
    this.showControls()
    this.nextSlide()
  }

  clickPrevious() {
    this.showControls()
    this.previousSlide()
  }

  handlePan(event) {
    if (event.target.closest('.js-sd-player-scrubber')) {
      return;
    }

    if (!this.isPanning()) {
      this.setPanningOn(event.additionalEvent)
    }

    this.slidePresenterElement.style.transform = `translateX(${event.deltaX}px)`

    if (event.isFinal) {
      if (this.panningDirection == event.additionalEvent) {
        if (event.additionalEvent == 'panright') {
          this.panToPrevious()
        } else {
          this.panToNext()
        }
      } else {
        this.resetPan()
      }
    }
  }

  setPanningOn(direction) {
    this.panning = true
    this.panningDirection = direction
    this.element.classList.add('is-panning')
    this.hideControls()
  }

  setPanningOff() {
    this.panning = false
    this.panningDirection = null
    this.element.classList.remove('is-panning')
  }

  isPanning() {
    return this.panning || false
  }

  panToNext() {
    if (this.isLastSlide()) {
      this.resetPan()
    } else {
      this.slidePresenterElement.style.transform = `translateX(-100%)`

      setTimeout(() => {
        this.setPanningOff()
        this.showSlide(this.currentSlide + 1)
        this.resetPan()
      }, 240)
    }
  }

  panToPrevious() {
    if (this.isFirstSlide()) {
      this.resetPan()
    } else {
      this.slidePresenterElement.style.transform = `translateX(100%)`
      setTimeout(() => {
        this.setPanningOff()
        this.showSlide(this.currentSlide - 1)
        this.resetPan()
      }, 240)
    }
  }

  resetPan(transition = true) {
    this.slidePresenterElement.style.transform = `translateX(0)`
    setTimeout(this.setPanningOff.bind(this), 240)
  }

  removeInitialState() {
    this.element.classList.remove('state-initial')
  }

  toggleShare() {
    this.element.classList.toggle('sharing')
    document.querySelector('.sd-player-share-menu').removeAttribute('hidden')
    document.querySelector('.sd-player-share-menu-group-head').querySelector('button').focus()

    if (this.element.classList.contains('sharing')) {
      this.updateShareSlideLinks()
    }
  }

  toggleNotes(e) {
    if(this.currentSlideNote.innerHTML.length > 0) document.querySelector('.current-slide-note').toggleAttribute('hidden')
    this.showSlideNotes = (this.showSlideNotes == true) ? false : true
    document.querySelector('.js-sd-player-notes').classList.toggle('notes-on')
  }

  hideShare() {
    this.element.classList.remove('sharing')
    document.querySelector('.sd-player-share-menu').setAttribute('hidden', 'hidden')
    document.querySelector('.sd-player-share').focus()
  }

  selectShareAction(e) {
    const target = e.target
    const select = target.dataset.select
    const group = target.dataset.group

    target.classList.add('active')

    Array.from(document.querySelectorAll(`[data-select][data-group='${group}']`)).forEach((element) => {
      if (element != target) {
        element.classList.remove('active')
      }
    })

    Array.from(document.querySelectorAll(`[data-selected-by][data-group='${group}']`)).forEach((element) => {
      if (element.dataset.selectedBy == select) {
        element.classList.add('active')
      } else {
        element.classList.remove('active')
      }
    })
  }

  startScrubberDrag() {
    this.draggingScrubber = true
  }

  endScrubberDrag() {
    this.draggingScrubber = false
    this.showSlide(this.currentPreviewSlide)
  }

  showPreview(e) {
    cancelEvent(e)
    const slide = Math.round(this.slideCount * e.clientX / this.scrubberElement.offsetWidth)

    this.previewElement.classList.add('active')
    if (slide != this.currentPreviewSlide) {
      this.currentPreviewSlide = slide
      this.previewElement.style.backgroundImage = `url('${this.slideElements()[slide].dataset.previewUrl}')`
      this.positionPreview()
      if (this.draggingScrubber) {
        this.showSlide(this.currentPreviewSlide)
      }
    }
  }

  hidePreview(e) {
    this.previewElement.classList.remove('active')
  }

  sizePreview() {
    this.previewHeight = 80
    this.previewWidth = 80 * this.ratio
    this.previewElement.style.width = `${this.previewWidth}px`
    this.previewElement.style.height = `${this.previewHeight}px`
  }

  positionPreview() {
    const padding = 20
    const scrubberWidth = this.scrubberElement.offsetWidth
    const center = scrubberWidth * this.currentPreviewSlide / (this.slideCount - 1)
    left = center - (this.previewWidth / 2)
    if (left < padding) {
      left = padding
    } else if (left + this.previewWidth > scrubberWidth - padding) {
      left = scrubberWidth - padding - this.previewWidth
    }

    this.previewElement.style.left = `${left}px`
  }

  receiveMessage(e) {
    if (e.origin == `${window.location.protocol}//${window.location.host}` && e.data.type == 'keydown') {
      this.handleKeyDown(e.data.keyCode)
    }
  }

  handleKeyDown(code) {
    switch(code) {
      case 39: // right arrow
      case 32: // space
        this.hideControls()
        this.nextSlide()
        break;
      case 37: // left arrow
        this.hideControls()
        this.previousSlide()
        break;
    }
  }

  nextSlide() {
    if (!this.isLastSlide()) {
      this.showSlide(this.currentSlide + 1)
    }
  }

  previousSlide() {
    if (!this.isFirstSlide()) {
      this.showSlide(this.currentSlide - 1)
    }
  }
}

Player.init = () => {
  const element = document.querySelector('.js-sd-player')

  if (element) {
    new Player(element);
  }
}

module.exports = Player;
